package fr.frux.core.designsystem.components

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import fr.frux.core.designsystem.resources.Res
import fr.frux.core.designsystem.resources.ds_guide_body
import fr.frux.core.designsystem.resources.ds_guide_confirm
import fr.frux.core.designsystem.resources.ds_guide_title
import fr.frux.core.designsystem.theme.FruxSpacing
import org.jetbrains.compose.resources.stringResource

/**
 * « Que puis-je recenser ? » (spec onboarding de contribution §3) : ce qui est légitime à ajouter
 * et comment le faire. Ici et pas dans une feature : la carte de zone vide et le formulaire
 * d'ajout l'affichent tous deux, et deux features ne se voient pas.
 */
@Composable
fun ContributionGuide(
    onConfirm: () -> Unit,
    modifier: Modifier = Modifier,
) {
    Column(
        modifier = modifier.fillMaxWidth(),
        verticalArrangement = Arrangement.spacedBy(FruxSpacing.sm),
    ) {
        Text(
            text = stringResource(Res.string.ds_guide_title),
            style = MaterialTheme.typography.titleMedium,
        )
        Text(
            text = stringResource(Res.string.ds_guide_body),
            style = MaterialTheme.typography.bodyMedium,
            color = MaterialTheme.colorScheme.onSurfaceVariant,
        )
        FruxButton(
            text = stringResource(Res.string.ds_guide_confirm),
            onClick = onConfirm,
            style = FruxButtonStyle.Filled,
            modifier = Modifier.fillMaxWidth(),
        )
    }
}

/** La même aide en feuille modale. [onConfirm] décide de la suite, [onDismiss] ferme seulement. */
@Composable
fun ContributionGuideSheet(
    onDismiss: () -> Unit,
    onConfirm: () -> Unit,
) {
    FruxModalBottomSheet(onDismiss = onDismiss, skipPartiallyExpanded = true) {
        ContributionGuide(
            onConfirm = onConfirm,
            modifier = Modifier.padding(horizontal = FruxSpacing.md),
        )
        Spacer(Modifier.height(FruxSpacing.lg))
    }
}
